/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnshareSkillRequestBody,
  UnshareSkillRequestBody$Outbound,
  UnshareSkillRequestBody$outboundSchema,
} from "../components/unshareskillrequestbody.js";

export type UnshareSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UnshareSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UnshareSkillSecurity = {
  option1?: UnshareSkillSecurityOption1 | undefined;
  option2?: UnshareSkillSecurityOption2 | undefined;
};

export type UnshareSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unshareSkillRequestBody: UnshareSkillRequestBody;
};

/** @internal */
export type UnshareSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UnshareSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  UnshareSkillSecurityOption1$Outbound,
  UnshareSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function unshareSkillSecurityOption1ToJSON(
  unshareSkillSecurityOption1: UnshareSkillSecurityOption1,
): string {
  return JSON.stringify(
    UnshareSkillSecurityOption1$outboundSchema.parse(
      unshareSkillSecurityOption1,
    ),
  );
}

/** @internal */
export type UnshareSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UnshareSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  UnshareSkillSecurityOption2$Outbound,
  UnshareSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function unshareSkillSecurityOption2ToJSON(
  unshareSkillSecurityOption2: UnshareSkillSecurityOption2,
): string {
  return JSON.stringify(
    UnshareSkillSecurityOption2$outboundSchema.parse(
      unshareSkillSecurityOption2,
    ),
  );
}

/** @internal */
export type UnshareSkillSecurity$Outbound = {
  Option1?: UnshareSkillSecurityOption1$Outbound | undefined;
  Option2?: UnshareSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UnshareSkillSecurity$outboundSchema: z.ZodMiniType<
  UnshareSkillSecurity$Outbound,
  UnshareSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UnshareSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UnshareSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function unshareSkillSecurityToJSON(
  unshareSkillSecurity: UnshareSkillSecurity,
): string {
  return JSON.stringify(
    UnshareSkillSecurity$outboundSchema.parse(unshareSkillSecurity),
  );
}

/** @internal */
export type UnshareSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnshareSkillRequestBody: UnshareSkillRequestBody$Outbound;
};

/** @internal */
export const UnshareSkillRequest$outboundSchema: z.ZodMiniType<
  UnshareSkillRequest$Outbound,
  UnshareSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    unshareSkillRequestBody: UnshareSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      unshareSkillRequestBody: "UnshareSkillRequestBody",
    });
  }),
);

export function unshareSkillRequestToJSON(
  unshareSkillRequest: UnshareSkillRequest,
): string {
  return JSON.stringify(
    UnshareSkillRequest$outboundSchema.parse(unshareSkillRequest),
  );
}
